import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import Checkbox from 'ext-ui/components/Checkbox/Checkbox'
import React from 'react'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface FilterSectionCheckboxFilterProps {
  headerSource: string
  checkboxProps: Array<{
    labelSource: string
    onChange: (checked: boolean) => void
    checked: boolean
  }>
}

const FilterSectionCheckboxFilter: React.FC<
  FilterSectionCheckboxFilterProps
> = (props): React.ReactElement => {
  const translate = useTranslate()

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 12px;
      `}
    >
      <div
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        {translate(props.headerSource)}
      </div>
      {props.checkboxProps.map((checkboxProp, index) => (
        <label
          key={index + checkboxProp.labelSource}
          css={css`
            display: flex;
            align-items: center;
            gap: 8px;
            cursor: pointer;
            ${getFontCss(
              14,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};
          `}
        >
          <Checkbox
            checked={checkboxProp.checked}
            onChange={(): void => {
              checkboxProp.onChange(!checkboxProp.checked)
            }}
            aria-label={translate(checkboxProp.labelSource)}
          />
          {translate(checkboxProp.labelSource)}
        </label>
      ))}
    </div>
  )
}

export default FilterSectionCheckboxFilter
